"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser_tracker_1 = require("@snowplow/browser-tracker");
var entities_1 = require("../../dataStructures/entities");
/**
 * Sets global contexts for the Snowplow Tracker
 *
 * @param globalContextsConfiguration any user set configuration options
 */
var setGlobalContexts = function setGlobalContexts() {
  var builtInGlobalContextProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var globalContextsConfiguration = arguments.length > 1 ? arguments[1] : undefined;
  if ((globalContextsConfiguration === null || globalContextsConfiguration === void 0 ? void 0 : globalContextsConfiguration.additionalGlobalContexts) !== undefined) {
    (0, browser_tracker_1.addGlobalContexts)(globalContextsConfiguration.additionalGlobalContexts);
  }
  var brandName = builtInGlobalContextProperties.brandName;
  if (brandName !== undefined) {
    var brandAttributes = (0, entities_1.brandAttributesContext)(brandName);
    if (brandAttributes !== undefined) {
      (0, browser_tracker_1.addGlobalContexts)([brandAttributes]);
    }
  }
};
exports["default"] = setGlobalContexts;